import { hostAddress } from 'data/helpers'

// Cookie + audit-log consent for cookies and session recording (Phase 1 of
// docs/SessionReplayConsentPlan.md). Shared contract with the backend
// (POST /api/tracking_consent) and the Next.js client — keep the cookie name,
// value format, and audit payload shape in sync with both if this changes.

const COOKIE_NAME = 'mystethi_consent'
const CONSENT_VERSION = 'v1'
const COOKIE_MAX_AGE_SECONDS = 31536000 // 1 year

const readCookie = name => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
  return match ? decodeURIComponent(match[1]) : null
}

const writeCookie = (name, value) => {
  document.cookie = `${name}=${value}; Path=/; Max-Age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax`
}

// 'accepted' | 'declined' | null (cookie absent = undecided)
export const getConsentDecision = () => {
  const raw = readCookie(COOKIE_NAME)
  if (raw === `${CONSENT_VERSION}:accepted`) return 'accepted'
  if (raw === `${CONSENT_VERSION}:declined`) return 'declined'
  return null
}

// Persist the decision (cookie) and fire the audit log. The audit POST is
// fire-and-forget: the cookie is the source of truth for the gate, so a
// failed audit call must never block Accept/Decline from taking effect.
export const recordConsentDecision = decision => {
  writeCookie(COOKIE_NAME, `${CONSENT_VERSION}:${decision}`)

  fetch(hostAddress('/api/tracking_consent'), {
    method: 'POST',
    headers: new Headers({ 'content-type': 'application/json' }),
    body: JSON.stringify({
      consented: decision === 'accepted',
      consentVersion: CONSENT_VERSION,
    }),
  }).catch(error => {
    console.error('Consent audit POST failed:', error)
  })
}
